import React, {forwardRef, useContext, useRef} from 'react';
import {Divider, Radio} from 'antd';
import PropTypes from 'prop-types';
import styles from './msg.form.module.less';
import _ from 'lodash';
import {useAuthStore} from '@/context/auth';
import UserSelect from '@/page/customer/MsgPage/UserSelect';
import {TeamOutlined} from '@/icons';
import MsgContext from '@/page/customer/MsgPage/msgContext';

const SendArea = forwardRef(({onSelect, isMoment = false, editable = false}, ref) => {
    const {
        count,
        setCount,
        sendType,
        setSendType,
        selectedUsers,
        setSelectedUsers,
        names,
        setNames,
    } = useContext(MsgContext);
    const [authStore] = useAuthStore();
    const userId = _.get(authStore, 'user.extId');
    const selectRef = useRef();

    function changeSendType(e) {
        setSendType(e.target.value);
        setCount(0);
        setNames('');
        setSelectedUsers([]);
    }

    function onReportLineUserSelect(parentId, values, sendGroupType) {
        const users = _.get(values, 'users', []);
        if (_.isEmpty(users)) {
            // message.warn('未选择任何用户');
            setCount(0);
            setNames('');
            setSelectedUsers(null);
            return false;
        }
        const subUserIds = users.map(({id}) => id);
        let str = '';
        users.forEach(item => {
            const {name} = item;
            str = str + ',' + name;
        });
        str = str.substr(1);
        setSelectedUsers(values);
        setCount(subUserIds.length);
        setNames(str);
        selectRef.current.closeModal();
        let type = 'singleCustomer';
        if (sendType === 2 && sendGroupType === 1) type = 'singleSender';
        if (sendType === 2 && sendGroupType === 2) type = 'group';
        onSelect(subUserIds, userId, type, users);
    }

    return (
        <div className={styles.container}>
            <div className={styles.send}>
                <Radio.Group value={sendType} onChange={changeSendType} disabled={!editable}>
                    {/*<Radio value={1}>*/}
                    {/*    个人群发*/}
                    {/*    <a*/}
                    {/*        href="#"*/}
                    {/*        style={{color: sendType === 2 && 'grey'}}*/}
                    {/*        onClick={() =>*/}
                    {/*            sendType === 1 &&*/}
                    {/*            selectRef.current.showModal(userId, selectedUsers, sendType)*/}
                    {/*        }*/}
                    {/*    >*/}
                    {/*        （选择范围）*/}
                    {/*    </a>*/}
                    {/*</Radio>*/}
                    <Radio value={2}>
                        企业群发
                        <a
                            href="#"
                            disabled={!editable}
                            style={{color: sendType === 1 && 'grey'}}
                            onClick={() =>
                                sendType === 2 &&
                                selectRef.current.showModal(userId, selectedUsers, sendType)
                            }
                        >
                            （选择范围）
                        </a>
                    </Radio>
                </Radio.Group>
                <Divider type="vertical" />
                <div>
                    &nbsp;
                    <TeamOutlined />
                    &nbsp; 已选择
                    <a href="#" title={names}>
                        {names.length > 30 ? names.substr(0, 27) + '...' : names}
                    </a>
                    {(count > 0 && '等') + count + '人'}
                </div>
                <UserSelect
                    ref={selectRef}
                    showTagTab={false}
                    showDepartTab={false}
                    onSelect={onReportLineUserSelect}
                    isMoment={isMoment}
                />
            </div>
        </div>
    );
});

SendArea.displayName = 'SendArea';

SendArea.propTypes = {};

export default SendArea;
